var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "waste-type-search u-12/12@xs u-6/12@md u-push-3/12@md u-4/12@lg u-push-4/12@lg u-relative@xs u-absolute@md"
    },
    [
      _c(
        "div",
        { staticClass: "waste-type-search__input-wrapper" },
        [
          _c("ElInput", {
            ref: "input",
            attrs: {
              size: "large",
              placeholder: "Wat wilt u weggooien?",
              "suffix-icon": "el-icon-search"
            },
            model: {
              value: _vm.keyword,
              callback: function($$v) {
                _vm.keyword = $$v
              },
              expression: "keyword"
            }
          }),
          _vm._v(" "),
          _vm.keyword.length
            ? _c(
                "ElButton",
                {
                  staticClass: "clear-button",
                  attrs: { type: "text" },
                  on: { click: _vm.clear }
                },
                [_c("i", { staticClass: "fa fa-times-circle" })]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.showResults
        ? _c(
            "div",
            {
              staticClass: "waste-type-search__results",
              class: { "show-results": _vm.keyword.length > 0 }
            },
            [
              _c("div", { staticStyle: { "margin-top": "60px" } }, [
                _vm.results.length > 0
                  ? _c(
                      "ul",
                      _vm._l(_vm.results.slice(0, 5), function(result, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            class: {
                              "active-result": _vm.arrowIndex === index
                            },
                            on: {
                              mouseover: function($event) {
                                return _vm.setActive(index)
                              },
                              mouseleave: function($event) {
                                return _vm.setActive(null)
                              }
                            }
                          },
                          [
                            _c("a", {
                              attrs: { href: "javascript:void(0)" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$options.filters.highlight(
                                    result.title,
                                    _vm.keyword
                                  )
                                )
                              },
                              on: {
                                click: function($event) {
                                  return _vm.setActiveWasteType(
                                    result.title,
                                    result.garbageTypeId
                                  )
                                }
                              }
                            })
                          ]
                        )
                      }),
                      0
                    )
                  : _c(
                      "div",
                      { staticClass: "u-ph-10" },
                      [
                        _c("FeedbackForm", {
                          attrs: {
                            payload: {
                              keyword: _vm.keyword,
                              activeWasteStreamId: _vm.activeWasteStreamId
                            },
                            "custom-cta": "Geen resultaten gevonden",
                            "custom-textarea-placeholder":
                              "Waar was u naar op zoek?"
                          }
                        })
                      ],
                      1
                    )
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }